(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('MlcClassController', MlcClassController);

    MlcClassController.$inject = ['$state', 'loginUser', 'MlcClass', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'MlcClassCategory', 'SchoolTerm', 'Registration'];

    function MlcClassController($state, loginUser, MlcClass, ParseLinks, AlertService, paginationConstants, pagingParams, MlcClassCategory, SchoolTerm, Registration) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.searchClass = searchClass;
        vm.getCHLClasses = getCHLClasses;
        vm.getCSLClasses = getCSLClasses;
        vm.getNonLangClasses = getNonLangClasses;
        vm.getAllClasses = loadAll;
        vm.mlcClassCategories = [];
        vm.mlcWeekendClassCategories = [];
        vm.mlcSummerClassCategories = [];
        vm.CHLCategoryId;
        vm.CSLCategoryId;
        vm.NonLangCategoryId;
        vm.schoolTerms = loadSchoolTerms;
        vm.getClassesBySchoolTerm = getClassesBySchoolTerm;
        vm.filterClasses = filterClasses;
        vm.loadCategories = loadCategories;
        vm.mlcClassTimes=[];
        vm.schoolTerms=[];

        vm.isAdmin = loginUser.authorities.includes('ROLE_ADMIN');

        loadSchoolTerms();

        function loadCategories() {
            MlcClassCategory.query(null,function(data){
                vm.mlcClassCategories = data;
                vm.mlcClassCategories.forEach(function(cat){
                    if(cat.type == 'SUMMER CAMP'){
                        if(cat.description == null || !cat.description.startsWith('INACTIVE')) {
                            vm.mlcSummerClassCategories.push(cat);
                        }
                    } else {
                        vm.mlcWeekendClassCategories.push(cat);
                    }
                    if(cat.name == 'CSL Chinese'){
                        vm.CSLCategoryId = cat.id;
                    } else if(cat.name == 'CHL Chinese'){
                        vm.CHLCategoryId = cat.id;
                    } else if(cat.name == 'NonLanguage'){
                        vm.NonLangCategoryId = cat.id;
                    }
                });
                if(vm.schoolTerm.type == "SUMMER CAMP"){
                    vm.mlcClassCategories = vm.mlcSummerClassCategories;
                } else {
                    vm.mlcClassCategories = vm.mlcWeekendClassCategories;
                }
            });
        }

        function loadAll () {
            MlcClass.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'className') {
                    result.push('className');
                }
                return result;
            }
        }

        function checkClassTime(mlcClass){
            if(vm.classTime){
                return mlcClass.classTime.classTime === vm.classTime;
            } else {
                return true;
            }
        }
        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;

            vm.mlcClasses = data.filter(checkClassTime);
            vm.mlcClassTimes = [];

            vm.mlcClasses.forEach(function(mlcClass){
                mlcClass.confirmed = 0;
                mlcClass.pending = 0;

                if(vm.mlcClassTimes.indexOf(mlcClass.classTime.classTime) === -1){
                    vm.mlcClassTimes.push(mlcClass.classTime.classTime);
                }

                if (mlcClass.classRoom && mlcClass.classRoom.roomNumber < 100){  // online classes
                    if(vm.isAdmin){
                        mlcClass.classRoom.roomNumber = mlcClass.classRoom.description;
                    } else {
                        mlcClass.classRoom.roomNumber = 'Online';
                    }
                }
                if (mlcClass.classRoom && mlcClass.classRoom.roomNumber > 1000){  // classes not in class room
                        mlcClass.classRoom.roomNumber = mlcClass.classRoom.description;
                }

                Registration.query({param : "registrationsForClass:"+mlcClass.id, size: 100}, function (registrations){
                    registrations.forEach(function(reg){
                       if(reg.status == 'CONFIRMED'){
                           mlcClass.confirmed += 1;
                       } else if(reg.status == 'PENDING'){
                           mlcClass.pending +=1;
                       }
                    });
                });
            });
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function onSchoolTermLoadSuccess() {
            vm.schoolTerm = vm.schoolTerms[0];
            getClassesBySchoolTerm();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        /*function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                category: vm.category? vm.category.id : null,
                schoolTerm: vm.schoolTerm? vm.schoolTerm.id : null,
                search: vm.currentSearch
            });
        }*/
        function transition() {
            var categoryId  = vm.category? vm.category.id : null;
            var schoolTermId = vm.schoolTerm? vm.schoolTerm.id : null;
            MlcClass.query({schoolTerm: schoolTermId, category: categoryId,
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            }, onSuccess, onError);
        }

        function searchClass(){
            vm.category = null;
            MlcClass.query({search: vm.searchTerm,
                schoolTerm: vm.schoolTerm.id,
                page: 0,
                size: vm.itemsPerPage,
                sort: 'className'
            }, onSuccess, onError);
        }

        function getCHLClasses(){
            MlcClass.query({category: vm.CHLCategoryId,
                page: 0,
                size: vm.itemsPerPage,
                sort: 'className'
            }, onSuccess, onError);
        }

        function getCSLClasses(){
            MlcClass.query({category: vm.CSLCategoryId,
                page: 0,
                size: vm.itemsPerPage,
                sort: 'className'
            }, onSuccess, onError);
        }

        function getNonLangClasses(){
            MlcClass.query({category: vm.NonLangCategoryId,
                page: 0,
                size: vm.itemsPerPage,
                sort: 'className'
            }, onSuccess, onError);
        }

        function loadSchoolTerms () {
            SchoolTerm.query(function(result) {
                if(vm.isAdmin) {
                    vm.schoolTerms = result;
                } else {
                    result.forEach(function(schoolTerm){
                        if(schoolTerm.status !== 'FINISHED'){
                            vm.schoolTerms.push(schoolTerm);
                        }
                    });
                }
                vm.searchQuery = null;
                vm.schoolTerm = vm.schoolTerms[0];
                vm.loadCategories();
                vm.getClassesBySchoolTerm();
            });
        }

        function getClassesBySchoolTerm() {
            MlcClass.query({schoolTerm: vm.schoolTerm.id,
                page: 0,
                size: vm.itemsPerPage,
                sort: 'className'
            }, onSuccess, onError);
        }

        function filterClasses () {
            vm.searchTerm = null;
            var categoryId  = vm.category? vm.category.id : null;
            var schoolTermId = vm.schoolTerm? vm.schoolTerm.id : null;
            var classTime = vm.classTime? vm.classTime : null;
            if(vm.schoolTerm.type == "SUMMER CAMP"){
                vm.mlcClassCategories = vm.mlcSummerClassCategories;
            } else {
                vm.mlcClassCategories = vm.mlcWeekendClassCategories;
            }
            MlcClass.query({schoolTerm: schoolTermId, category: categoryId,
                page: 0,
                size: vm.itemsPerPage,
                sort: 'className'
            }, onSuccess, onError);
        }
    }
})();
